import type { Dispatch, MouseEvent, SetStateAction } from 'react';
import type { DateItem } from '@/components/calendar/utils/dates';
import { EventTypes } from '@/domain';

interface ReplacePropsWithPreviewTypes {
    href?: string;
    onClick?: (event: MouseEvent) => void;
    rel?: string;
}

export const replacePropsWithPreview = (normalProps: ReplacePropsWithPreviewTypes, isPreview: boolean): ReplacePropsWithPreviewTypes => {
    if (isPreview) {
        return {
            onClick: (e: MouseEvent) => {
                e.preventDefault();
                alert('Knapper og lenker er skrudd av under forhåndsvisning');
            },
        };
    }
    return normalProps;
};

export const generateDayProps = (dateItem: DateItem): Record<string, string | boolean> => {
    const hasBookingEvent =
        dateItem.activeEvents?.some((event) => event.type === EventTypes.BOOKING || event.type === EventTypes.BOOKING_SELECT) || false;

    return hasBookingEvent ? { disabled: true } : {};
};

export const renderCurrency = (price: string) => (price.includes('NOK') ? price.replace('NOK', 'kr') : price);

type DateSetter = Dispatch<SetStateAction<Date | null>>;
type SelectChangeArgs = { startDate: Date | null; endDate: Date | null };

export const handleSelectChange =
    (isPreview: boolean, setSelectedStartDate: DateSetter, setSelectedEndDate: DateSetter) =>
    ({ startDate, endDate }: SelectChangeArgs): void => {
        if (!isPreview) {
            setSelectedStartDate(startDate);
            setSelectedEndDate(endDate);
        }
    };

export const handleDateReset =
    (setSelectedStartDate: DateSetter, setSelectedEndDate: DateSetter): (() => void) =>
    () => {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
    };
